import React from 'react';
import I18n from 'i18n-js';
import {
  core_apimessages_Channel,
  core_apimessages_NegotiationAction as NegotiationAction,
  core_apimessages_NegotiationParty,
} from '../../schemas/rql';
import bind from '@reverbdotcom/commons/src/bind';
import UpdateOfferModal from './update_offer_modal';
import classNames from 'classnames';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { refreshDashboard } from './refresh_dashboard';

interface IExternalProps {
  listingId: string;
  isSeller: boolean;
  negotiationId: string;
  negotiationAction: NegotiationAction;
}

type IProps = IUserContext & IExternalProps;

interface IState {
  openDialog: boolean;
}

export class UpdateOfferButton extends React.Component<IProps, IState> {

  state: IState = {
    openDialog: false,
  };

  @bind
  toggleModal() {
    this.setState((prevState) => ({ openDialog: !prevState.openDialog }));
  }

  get offerButtonText() {
    const action = this.props.negotiationAction.toLocaleLowerCase();
    return I18n.t(`discovery.offers.action.${action}`);
  }

  @bind
  handleClose() {
    this.setState({ openDialog: false });
  }

  @bind
  handleSuccess(requestingParty: core_apimessages_NegotiationParty) {
    const updateOfferMessage = I18n.t('discovery.offers.updateSubmissionSuccess');
    refreshDashboard(this.props.negotiationId, updateOfferMessage, requestingParty);
  }

  render() {
    return (
      <div>
        <button className={classNames(
          'offer-action', {
            'offer-action--accept': this.props.negotiationAction === NegotiationAction.ACCEPT,
            'offer-action--reject': this.props.negotiationAction === NegotiationAction.REJECT,
            'offer-action--counter': this.props.negotiationAction === NegotiationAction.COUNTER,
          })} onClick={this.toggleModal} type="button">
          {this.offerButtonText}
        </button>
        <UpdateOfferModal
          onRequestDialogClose={this.handleClose}
          isDialogOpen={this.state.openDialog}
          isSeller={this.props.isSeller}
          onSuccess={this.handleSuccess}
          listingId={this.props.listingId}
          negotiationId={this.props.negotiationId}
          negotiationAction={this.props.negotiationAction}
          shopChannel={core_apimessages_Channel.REVERB}
        />
      </div>
    );
  }
}

export default withUserContext<IExternalProps>(UpdateOfferButton);
